import styled from "@emotion/styled";
import { ThemeKey } from "@smartsheet/design-tokens";
import { Spacer } from "../../../layout";
import { datePickerTheme } from "./datePickerTheme";

interface DatePickerFooterProps {
    themeMode: ThemeKey;
}

const shouldForwardProp = (propName: string) => propName !== "themeMode";

export const DatePickerFooter = styled(Spacer, { shouldForwardProp })<DatePickerFooterProps>`
    justify-content: center;
    margin-top: ${({ themeMode }) => datePickerTheme.footer.marginTop(themeMode)};
`;
